import type { MentionDescription } from '@atlaskit/mention';
import { getNonPublicIfAvailable } from '@trello/business-logic/member';
import { dangerouslyConvertPrivacyString } from '@trello/privacy';

import type { TrelloMember } from './TrelloMember';

export function toMemberMention(
  trelloMember: TrelloMember,
): MentionDescription {
  const username = dangerouslyConvertPrivacyString(trelloMember.username);
  const fullName = dangerouslyConvertPrivacyString(
    getNonPublicIfAvailable(trelloMember, 'fullName'),
  );
  const avatar = dangerouslyConvertPrivacyString(
    getNonPublicIfAvailable(trelloMember, 'avatarUrl'),
  );
  const avatarUrl = avatar ? `${avatar}/50.png` : undefined;

  return {
    id: trelloMember.id,
    avatarUrl,
    name: fullName ?? username,
    nickname: username,
    mentionName: username,
    userType: trelloMember.type ?? 'user',
  };
}
